module.exports = __webpack_public_path__ + "static/media/BlackPanther.401e22f0.jpg";